export default __webpack_public_path__ + "static/media/FlyingFrog23.f39fc707.png";